import { useContext, useEffect, useState } from "react";
import { Context } from "../../Context";
import { useNavigate, useParams } from "react-router-dom";
import FinishedGoal from "../../Components/FinishedGoal";
import FinishedSurvey from "../../Components/FinishedSurvey";
import Loading from "../../Components/Loading";
import WidgetService from "../../Services/widgetService";
import "./style.scss";

function Frame() {
  const navigate = useNavigate();
  const { setCampaign, setServer } = useContext(Context);
  const { carouselName } = useParams();
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showFinishedGoal, setShowFinishedGoal] = useState(false);
  const [showFinishedSurvey, setShowFinishedSurvey] = useState(false);

  const clearCookies = async () => {
    let controllers = localStorage.getItem("121-widget-carousel");
    if (controllers && controllers !== "") {
      controllers = controllers.split(";");
      controllers = controllers.filter((controller) => controller !== "");

      const response = await WidgetService.controllersCheck({
        carousel_name: carouselName,
        controllers: controllers,
      });

      if (Array.isArray(response?.data)) {
        for (let i = 0; i < response.data.length; i++) {
          let position = controllers.indexOf(response.data[i]);
          controllers.splice(position, 1);
        }
        localStorage.setItem("121-widget-carousel", controllers.join(";"));
      }
    }

    return controllers;
  };

  const getCarouselData = async () => {
    let controllers = localStorage.getItem("121-widget-carousel");

    if (controllers === "") {
      controllers = null;
    }

    if (controllers) {
      controllers = controllers.split(";");
      controllers = controllers.filter((controller) => controller !== "");
    }

    const response = await WidgetService.main({
      carousel_name: carouselName,
      controllers: controllers,
    });

    if (response?.data?.campaign) {
      if (controllers) {
        if (controllers.indexOf(response.data.controller) === -1) {
          controllers = [...controllers, response.data.controller];
        }
      } else {
        controllers = [response.data.controller];
      }
      localStorage.setItem("121-widget-carousel", controllers.join(";"));
      return response.data;
    }
    return response.data;
  };

  const handleLogic = async () => {
    await clearCookies();
    const carousel = await getCarouselData();
    if (carousel?.campaign) {
      setCampaign(carousel.campaign);
      setServer(carousel.server);
      setLink(carousel.full_url);
      setLoading(false);
    } else {
      handleCarouselFinished(carousel);
    }
  };

  useEffect(() => {
    if (!link) {
      handleLogic();
    }
  }, [link]);

  const handlePostMessage = async (event) => {
    if (
      (event.origin === process.env.REACT_APP_POST_MESSAGE_HAZO_ME &&
        event.data === "Survey has ended") ||
      (event.origin === process.env.REACT_APP_POST_MESSAGE_HAZO_AI &&
        event.data === "Survey has ended AI")
    ) {
      setLoading(true);
      const carousel = await getCarouselData();
      if (carousel?.campaign) {
        setLoading(false);
        navigate(`/intermediary/${carouselName}`);
      } else {
        handleCarouselFinished(carousel);
      }
    }
  };

  // Funcao feita apenas para testar cagadas
  // const handlePostMessageTest = async (event) => {
  //   setLoading(true);
  //   const carousel = await getCarouselData();
  //   if (carousel?.campaign) {
  //     setLoading(false);
  //     navigate(`/intermediary/${carouselName}`);
  //   } else {
  //     handleCarouselFinished(carousel);
  //   }
  // };

  useEffect(() => {
    window.addEventListener("message", (event) => {
      handlePostMessage(event);
    });
    // eslint-disable-next-line
  }, []);

  const handleCarouselFinished = (carouselResponse) => {
    switch (carouselResponse) {
      case "All chatbots have already reached the goal.":
        setShowFinishedGoal(true);
        setLoading(false);
        break;
      case "Carousel unavaliable.":
      case "All controllers have already answered.":
        setShowFinishedSurvey(true);
        setLoading(false);
        break;
      default:
        navigate("/notfound/");
        break;
    }
  };

  if (showFinishedGoal) {
    return <FinishedGoal carouselName={carouselName} />;
  }

  if (showFinishedSurvey) {
    return <FinishedSurvey carouselName={carouselName} />;
  }

  if (!loading) {
    return (
      <div className="compApp">
        {/* Botao desenvolvido para testar cagadas */}
        {/* <button onClick={() => handlePostMessageTest()}>post message</button> */}
        <iframe src={link} frameBorder="0"></iframe>
      </div>
    );
  } else {
    return <Loading />;
  }
}

export default Frame;
